import { useBehavior, useTriggerAction } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TSignInWithGoogleData } from '../../types/data';
import { ConsumerActionTypeEnums } from '../../types/enums';
import { TSignInWithGoogleOptions } from '../../types/options';
import { ButtonSocialView } from './ButtonSocialView';
import { useGoogleLogin } from '@react-oauth/google';

/**
 *
 * The Google JS SDK is loaded clientId from a global variable that must be set in the .env file
 *   NX_PUBLIC_GLOBAL_googleAuthClientId='com.paysend.web'
 *
 * If Sign In With Apple is unavailable (SDK missing / not loaded), nothing is rendered.
 */
export const ButtonSignInWithGoogle = ({ widget }: TWidgetProps<TSignInWithGoogleData, TSignInWithGoogleOptions>) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { messages } = widget.data ?? ({} as TSignInWithGoogleData);
    const { hierarchy = 'circle' } = widget.options ?? ({} as TSignInWithGoogleOptions);

    const login = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            triggerActionsByType(ConsumerActionTypeEnums.onSuccess, { value: tokenResponse }).then();
        },
        onError: (error) => {
            triggerActionsByType(ConsumerActionTypeEnums.onFailure, { value: error }).then();
        },
    });

    return (
        <ButtonSocialView
            widget={widget}
            isHide={isHidden}
            isDisabled={isDisabled}
            label={messages?.label}
            uid={widget.uid}
            isCircle={hierarchy === 'circle'}
            authProvider="google"
            onClick={() => login()}
        />
    );
};
